// PECR (Privacy and Electronic Communications Regulations) 2003 compliance
// UK GDPR Article 5: Lawfulness, fairness, transparency

export default function CookiePolicy() {
  return (
    <div className="page-container">
      <div className="content-wrapper">
        <div className="page-header">
          <h1 className="page-title">Cookie Policy</h1>
        </div>
        
        <div className="prose space-y-6">
          <p className="text-sm text-muted-foreground">
            <strong>Last Updated:</strong> 16 October 2025<br />
            <strong>Data Controller:</strong> Second Chance Connect Ltd
          </p>

          <section>
            <h2 className="text-2xl font-semibold mb-4">What Are Cookies?</h2>
            <p>
              Cookies are small text files placed on your device when you visit our website. They help us
              provide you with a better experience by remembering your preferences and enabling essential
              functionality.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Cookies We Use</h2>
            
            <h3 className="text-xl font-semibold mt-4 mb-2">Strictly Necessary Cookies</h3>
            <p>
              These cookies are essential for the platform to function and cannot be switched off. They are
              usually set in response to actions you take, such as signing in or setting privacy preferences.
            </p>
            <table className="min-w-full border border-border mt-2">
              <thead className="bg-muted">
                <tr>
                  <th className="border border-border px-4 py-2">Cookie Name</th>
                  <th className="border border-border px-4 py-2">Purpose</th>
                  <th className="border border-border px-4 py-2">Duration</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-border px-4 py-2">supabase-auth-token</td>
                  <td className="border border-border px-4 py-2">Authentication and session management</td>
                  <td className="border border-border px-4 py-2">Session</td>
                </tr>
                <tr>
                  <td className="border border-border px-4 py-2">sb-access-token</td>
                  <td className="border border-border px-4 py-2">Maintain your login session securely</td>
                  <td className="border border-border px-4 py-2">7 days</td>
                </tr>
                <tr>
                  <td className="border border-border px-4 py-2">sb-refresh-token</td>
                  <td className="border border-border px-4 py-2">Refresh authentication token</td>
                  <td className="border border-border px-4 py-2">30 days</td>
                </tr>
              </tbody>
            </table>

            <h3 className="text-xl font-semibold mt-6 mb-2">Analytics Cookies (Not Currently Used)</h3>
            <p>
              We do not currently use analytics cookies. If we introduce them in the future, we will request
              your explicit consent and update this policy.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-2">Marketing Cookies (Not Used)</h3>
            <p>
              We do not use marketing or advertising cookies. Your data is not shared with third-party
              advertisers.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Your Cookie Choices</h2>
            <p>
              You can control cookies through your browser settings. However, disabling strictly necessary
              cookies will prevent you from using core platform features like signing in.
            </p>
            <p className="mt-2">
              <strong>Browser Cookie Controls:</strong>
            </p>
            <ul className="list-disc ml-6">
              <li><strong>Chrome:</strong> Settings → Privacy and Security → Cookies</li>
              <li><strong>Firefox:</strong> Settings → Privacy & Security → Cookies and Site Data</li>
              <li><strong>Safari:</strong> Preferences → Privacy → Cookies and website data</li>
              <li><strong>Edge:</strong> Settings → Cookies and site permissions</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Third-Party Cookies</h2>
            <p>
              We do not use third-party tracking cookies. Our cloud infrastructure provider (Lovable Cloud)
              may set cookies for service provision, but these are strictly necessary and do not track you
              across other websites.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Updates to This Policy</h2>
            <p>
              We may update this Cookie Policy to reflect changes in our practices or legal requirements.
              We will notify you of significant changes via email or platform notice.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
            <p>
              If you have questions about our use of cookies, please contact us at{" "}
              <a href="mailto:admin@sccapp.co.uk" className="text-primary underline">
                admin@sccapp.co.uk
              </a>
            </p>
          </section>

          <div className="mt-12 p-6 bg-muted rounded-lg">
            <p className="text-sm">
              <strong>Compliance:</strong> This Cookie Policy complies with UK GDPR, the Data Protection Act 2018,
              and the Privacy and Electronic Communications Regulations (PECR) 2003.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
